import { ArdoqId, APIScenarioScopeData } from '@ardoq/api-types';
import {
  fixDiffContext,
  removeDanglingReferencesInScopeData,
} from 'scopeData/utils/fixScopeData';
import { ApiResponse, scenarioApi } from '@ardoq/api';
import { isArdoqError } from '@ardoq/common-helpers';

export const loadAndFixScenario = async (
  scenarioId: ArdoqId
): ApiResponse<APIScenarioScopeData> => {
  const result = await scenarioApi.load(scenarioId);
  if (isArdoqError(result)) {
    return result;
  }
  return removeDanglingReferencesInScopeData(result, scenarioId);
};

export const loadAndFixDiffContext = async (scenarioId: ArdoqId) => {
  const result = await scenarioApi.diffContext(scenarioId);
  if (isArdoqError(result)) {
    return result;
  }
  return { ...result, response: fixDiffContext(result, scenarioId) };
};

export const copyScenario = async ({
  scenarioId,
  scenarioCopyName,
}: {
  scenarioId: ArdoqId;
  scenarioCopyName: string;
}) => await scenarioApi.copy(scenarioId, scenarioCopyName);

export const updateBranchOffPoint = async (scenarioId: ArdoqId) =>
  await scenarioApi.updateBranchOff(scenarioId);
